import { call, put, takeLatest } from "redux-saga/effects";
import { httpSingleParticipants } from "../../../services/quizathon";
import {
  getSingleParticipantFailure,
  getSingleParticipantStart,
  getSingleParticipantSuccess,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";

function* getSingleParticipant({ payload }) {
  const response = yield call(httpSingleParticipants, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getSingleParticipantSuccess(raw));
  } else {
    yield put(getSingleParticipantFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onGetSingleParticipant() {
  yield takeLatest(getSingleParticipantStart.type, getSingleParticipant);
}
